/**
 * Opens/closes the Lead Time "Learn more" native <dialog> on the PDP.
 *
 * Markup hooks (queried by data-attribute):
 *   [data-relic-lead-time-modal-open]   — trigger button (aria-controls → dialog id)
 *   [data-relic-lead-time-modal]        — <dialog> element
 *   [data-relic-lead-time-modal-close]  — close button inside dialog
 *   [data-relic-lead-time-modal-video]  — <video> paused/reset on close
 */
function pauseLeadTimeModalVideo(dialog) {
  const video = dialog.querySelector('[data-relic-lead-time-modal-video]');
  if (!video) return;

  video.pause();
  video.currentTime = 0;
}

function bindLeadTimeModal(dialog) {
  if (dialog.dataset.relicLeadTimeModalBackdropInit) return;
  dialog.dataset.relicLeadTimeModalBackdropInit = 'true';

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });

  dialog.addEventListener('close', () => {
    pauseLeadTimeModalVideo(dialog);
  });
}

function initRelicLeadTimeModals() {
  if (!window.__relicLeadTimeModalsClickInit) {
    window.__relicLeadTimeModalsClickInit = true;

    document.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-relic-lead-time-modal-open]');
      if (openTrigger) {
        const dialogId = openTrigger.getAttribute('aria-controls');
        const dialog = dialogId ? document.getElementById(dialogId) : null;

        if (dialog?.matches('[data-relic-lead-time-modal]')) {
          event.preventDefault();
          dialog.showModal();
        }
        return;
      }

      const closeTrigger = event.target.closest('[data-relic-lead-time-modal-close]');
      if (closeTrigger) {
        const dialog = closeTrigger.closest('[data-relic-lead-time-modal]');
        dialog?.close();
      }
    });
  }

  document.querySelectorAll('[data-relic-lead-time-modal]').forEach(bindLeadTimeModal);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelicLeadTimeModals);
} else {
  initRelicLeadTimeModals();
}

document.addEventListener('shopify:section:load', initRelicLeadTimeModals);
